export default {
  nav: {
    home: "მთავარი",
    services: "სერვისები",
    about: "ჩვენს შესახებ",
    contact: "კონტაქტი",
    book: "დაჯავშნე",
  },
  hero: {
    badge: "დაარსდა 2012 — 3,800+ კმაყოფილი კლიენტი",
    line1: "სუფთა სივრცე,",
    line2: "სუფთა გონება.",
    sub: "პროფესიონალური დასუფთავების სერვისი სახლებისა და ბიზნესისთვის — სიზუსტით, ზრუნვით და ყურადღებით.",
    btn1: "დაჯავშნე",
    btn2: "სერვისები",
    scroll: "გადახვევა",
  },
  partners: "ჩვენი პარტნიორები",
  stats: {
    exp: "წლიანი გამოცდილება",
    clients: "მომსახურებული კლიენტი",
    satisfaction: "კმაყოფილების მაჩვენებელი",
    support: "მხარდაჭერა",
  },
  services: {
    pageTitle: "ჩვენი სერვისები — Cleaning Holding",
    pageMeta: "გაეცანით Cleaning Holding-ის სრულ სერვისების ჩამონათვალს.",
    pageSubtitle:
      "ყველა სერვისი სრულდება ერთი და იმავე სტანდარტით — ზუსტად, საფუძვლიანად და თქვენზე მორგებულად.",
    label: "რას გთავაზობთ",
    title: "ჩვენი სერვისები",
    ctaTitle: "მზად ხარ დასაწყებად?",
    ctaSub: "დაგვიკავშირდი უფასო კონსულტაციისთვის.",
    ctaBtn: "კონსულტაციის მოთხოვნა",
    learnMore: "გაიგე მეტი",
    viewAll: "ყველა სერვისი",
    residential: {
      title: "საცხოვრებელი დასუფთავება",
      subtitle: "შენი სახლი — სრულყოფილი",
      desc: "სახლის პრემიუმ დასუფთავება თქვენი განრიგის მიხედვით.",
      fullDesc:
        "ყველა სახლს ვექცევით როგორც საკუთარს. ჩვენი პროფესიონალები იყენებენ ეკო-სერტიფიცირებულ საშუალებებს სრული სისუფთავისთვის.",
      f1: "რეგულარული მოვლა",
      f2: "ოთახების სრული დასუფთავება",
      f3: "სამზარეულოს და სააბაზანოს სანიტარია",
      f4: "ფანჯრების და ზედაპირების გაპრიალება",
    },
    commercial: {
      title: "კომერციული დასუფთავება",
      subtitle: "სივრცეები, რომლებიც შთააგონებენ",
      desc: "ოფისის და ობიექტის პრემიუმ დასუფთავება.",
      fullDesc:
        "პირველი შთაბეჭდილება მნიშვნელოვანია. ვინარჩუნებთ სისუფთავეს ოფისებში, სავაჭრო სივრცეებსა და ობიექტებში.",
      f1: "ოფისის დასუფთავება",
      f2: "სავაჭრო სივრცის დასუფთავება",
      f3: "ღონისძიების შემდგომი დასუფთავება",
      f4: "რეგულარული ობიექტის მოვლა",
    },
    deep: {
      title: "გენერალური დასუფთავება",
      subtitle: "ზემოდან ქვემოდამდე",
      desc: "საფუძვლიანი დასუფთავება ყველა კუთხეში.",
      fullDesc:
        "როდესაც ჩვეულებრივი დასუფთავება არ კმარა. ჩვენი გენერალური დასუფთავება ყველა კუთხეს, ნაპრალს და ზედაპირს მოიცავს.",
      f1: "სრული სახლის გენდასუფთავება",
      f2: "ტექნიკის შიდა გაწმენდა",
      f3: "ფილების და ნაკერების გაახლება",
      f4: "სავენტილაციო სისტემის გაწმენდა",
    },
    move: {
      title: "გადასვლის დასუფთავება",
      subtitle: "სუფთა დასაწყისი და დასასრული",
      desc: "ახალ სახლში — სუფთა დასაწყისი.",
      fullDesc:
        "გადასვლა საკმარისად სტრესულია. მიანდე დასუფთავება ჩვენ და ყურადღება მიაქციე მნიშვნელოვანს.",
      f1: "სრული სანიტარია",
      f2: "კარადებისა და უჯრების გაწმენდა",
      f3: "კედლების ლაქების მოცილება",
      f4: "მემამულისთვის მზა ინსპექცია",
    },
    construction: {
      title: "სამშენებლო დასუფთავება",
      subtitle: "გამოავლინე ქვეშ დამალული სილამაზე",
      desc: "სპეციალიზებული სამშენებლო დასუფთავება.",
      fullDesc:
        "მშენებლობა ტოვებს მტვერს, ნარჩენებს და ნაშთებს. ჩვენ სამუშაო მოედანს საცხოვრებელ სივრცედ ვაქცევთ.",
      f1: "მტვრის და ნარჩენების მოცილება",
      f2: "ზედაპირების და იატაკის გაპრიალება",
      f3: "ფანჯრების გაწმენდა",
      f4: "საბოლოო ინსპექცია",
    },
    recurring: {
      title: "რეგულარული პაკეტები",
      subtitle: "მუდმივი სრულყოფილება",
      desc: "ყოველკვირეული, ყოველორკვირეული და ყოველთვიური პაკეტები.",
      fullDesc:
        "შეინარჩუნე სტანდარტი. ჩვენი პაკეტები უზრუნველყოფს, რომ შენი სივრცე ყოველთვის სტუმრებისთვის მზად იყოს.",
      f1: "ყოველკვირა / ყოველ2კვირა / ყოველთვე",
      f2: "გამოყოფილი გუნდი",
      f3: "ინდივიდუალური ჩეკ-ლისტი",
      f4: "პრიორიტეტული განრიგი",
    },
  },
  process: {
    label: "როგორ მუშაობს",
    title: "ჩვენი პროცესი",
    step1: {
      title: "ონლაინ დაჯავშნა",
      desc: "აირჩიე სერვისი და სასურველი თარიღი რამდენიმე წუთში.",
    },
    step2: {
      title: "ვადასტურებთ",
      desc: "ჩვენი გუნდი 2 საათში განიხილავს და ადასტურებს.",
    },
    step3: {
      title: "ვასუფთავებთ",
      desc: "პროფესიონალები დროულად ჩამოდიან ყველა აღჭურვილობით.",
    },
    step4: {
      title: "ისიამოვნე",
      desc: "შეამოწმე შედეგი და ისიამოვნე სუფთა სივრცით.",
    },
  },
  cta: {
    title: "მზად ხარ სუფთა სივრცისთვის?",
    sub: "მიიღე უფასო კონსულტაცია — ვალდებულების გარეშე.",
    btn: "უფასო კონსულტაცია",
  },
  about: {
    pageTitle: "ჩვენს შესახებ — Cleaning Holding",
    pageMeta:
      "გაიცანით Cleaning Holding — 12 წლიანი პრემიუმ დასუფთავების გამოცდილება.",
    label: "ჩვენი ისტორია",
    title: "ჩვენს შესახებ",
    subtitle:
      "ათწლეული헌신, ათასობით კმაყოფილი კლიენტი და ერთი უცვლელი სტანდარტი — სრულყოფილება.",
    since: "2012 წლიდან",
    storyTitle: "ნდობაზე დაფუძნებული",
    story1:
      "Cleaning Holding დაარსდა 2012 წელს მარტივი, მაგრამ ძლიერი რწმენით: ყველა სივრცე იმსახურებს ზრუნვასა და სიზუსტეს. პატარა საცხოვრებელი დასუფთავების კომპანიიდან გავიზარდეთ სრულ სერვისულ კომპანიად, რომელსაც ათასობით სახლი და ბიზნესი ენდობა.",
    story2:
      "ბოლო 12 წლის განმავლობაში ჩამოვაყალიბეთ სანდოობის, კონფიდენციალობის და ხარისხისადმი ერთგულების რეპუტაცია. ჩვენი კლიენტები არ გვიქირავებენ — ისინი გვენდობიან.",
    quote:
      "ჩვენ არ ვასუფთავებთ მხოლოდ სივრცეს — ჩვენ ვაბრუნებთ სიმშვიდეს, წესრიგს და სიამაყეს ყველა გარემოში.",
    valuesLabel: "რა გვამოძრავებს",
    valuesTitle: "ჩვენი ღირებულებები",
    teamLabel: "ადამიანები სრულყოფილების უკან",
    teamTitle: "გაიცანით გუნდი",
    ctaTitle: "ვიმუშაოთ ერთად",
    ctaSub: "შეიგრძენი Cleaning Holding-ის განსხვავება პირველივე სერვისიდან.",
    ctaBtn: "დაგვიკავშირდი",
    values: {
      v1: {
        title: "პრემიუმ ხარისხი",
        desc: "ვიყენებთ მხოლოდ საუკეთესო ეკო-სერტიფიცირებულ პროდუქტებს და ვახორციელებთ მკაცრ ხარისხის კონტროლს.",
      },
      v2: {
        title: "ნდობა და პატიოსნება",
        desc: "სრულად შემოწმებული, დაზღვეული და ფონის შემოწმებული პროფესიონალები.",
      },
      v3: {
        title: "სანდოობა",
        desc: "დროულად, ყოველთვის. ვაფასებთ თქვენს განრიგს და ვაწვდით სტაბილურ შედეგებს.",
      },
      v4: {
        title: "ეკოლოგიური ცნობიერება",
        desc: "მდგრადი დასუფთავების გადაწყვეტილებები, რომლებიც იცავს თქვენს ოჯახს, შინაურ ცხოველებს და გარემოს.",
      },
    },
    team: { exp: "გამოცდილება" },
  },
  contact: {
    pageTitle: "კონტაქტი — Cleaning Holding",
    pageMeta: "დაგვიკავშირდი Cleaning Holding-თან უფასო კონსულტაციისთვის.",
    label: "დაგვიკავშირდი",
    title: "კონტაქტი",
    subtitle:
      "მზად ხარ სუფთა სივრცისთვის? დაგვიკავშირდი და 2 საათში გიპასუხებთ უფასო შეფასებით.",
    formTitle: "შეტყობინების გაგზავნა",
    formSub: "2 სამუშაო საათში გიპასუხებთ.",
    name: "სახელი და გვარი",
    email: "ელ-ფოსტა",
    phone: "ტელეფონი",
    service: "საჭირო სერვისი",
    message: "შეტყობინება",
    selectService: "აირჩიე სერვისი...",
    send: "გაგზავნა",
    successTitle: "გმადლობთ!",
    successMsg:
      "თქვენი შეტყობინება მიღებულია. ჩვენი გუნდი მალე დაგიკავშირდებათ.",
    infoTitle: "საკონტაქტო ინფორმაცია",
    infoSub: "ყოველთვის სიამოვნებით გისმენთ.",
    whyTitle: "რატომ ჩვენ",
    why1: "უფასო კონსულტაცია და შეფასება",
    why2: "2 საათში პასუხი",
    why3: "სრულად დაზღვეული გუნდი",
    why4: "მოქნილი განრიგი",
    address: "მისამართი",
    phoneLabel: "ტელეფონი",
    emailLabel: "ელ-ფოსტა",
    hoursLabel: "სამუშაო საათები",
    services: {
      residential: "dalageba, საცხოვრებელი დასუფთავება",
      commercial: "dalageba, კომერციული დასუფთავება",
      deep: "dasuftaveba, გენერალური დასუფთავება",
      moveinout: "გადასვლის დასუფთავება",
      postconstruction: "სამშენებლო დასუფთავება",
      recurring: "რეგულარული პაკეტი",
    },
  },
};
